import { render, staticRenderFns } from "./EditRemitterCreditModel.vue?vue&type=template&id=7f163b2b"
import script from "./EditRemitterCreditModel.vue?vue&type=script&lang=js"
export * from "./EditRemitterCreditModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports